import React, {Component} from "react";
import {createBrowserHistory} from "history";
import {Redirect, Route as NeutralRoute, Router, Switch} from "react-router-dom";
import Login from "./views/login";
import ResetPassword from "./views/reset-password";
import ResetPasswordConfirm from "./views/reset-password-confirm";
import LocalStorage from "./util/localStorage";
import NotFoundView from "./views/not-found";
import RegisterView from "./views/register";
import {checkPerm, READ_PERM} from "./util/util";
import Resources from "./data/services/resources";
import ClientsPage from "./views/clients-page";
import ClientSinglePage from "./views/client-single-page";
import ClientProfilePage from "./views/ext-client-profile-page";
import PhysiciansPage from "./views/physicians-page";
import LocationsPage from "./views/locations-page";
import UsersPage from "./views/users-page";
import PreferencesPage from "./views/preferences-page";
import WelcomePage from "./views/welcome-page";
import AilmentsPage from "./views/ailments-page";
import AilmentsSinglePage from "./views/ailment-single-page";
import SurveysPage from "./views/surveys-page";
import SurveysSinglePage from "./views/survey-single-page";
import LookupAilmentsPage from "./views/settings-ailments";
import LoggedDevicesPage from "./views/logged-devices-page";

const PrivateRoute = ({component: Component, ...rest}) => (
    <NeutralRoute
        {...rest}
        render={props =>
            (!!LocalStorage.get('user')) ? (<Component {...props}/>) : (
                <Redirect to={{
                    pathname: "/login",
                    state: {from: props.location}
                }}/>
            )
        }
    />
);

const PublicRoute = ({component: Component, ...rest}) => (
    <NeutralRoute
        {...rest}
        render={props =>
            (!LocalStorage.get('user')) ? (<Component {...props}/>) : (
                <Redirect to={{
                    pathname: checkPerm(Resources.Clients, READ_PERM) ? "/clients" : (checkPerm(Resources.ExtRoles, READ_PERM) ? "/clients" : "/clients"),
                    state: {from: props.location}
                }}/>
            )
        }
    />
);

class RouterListener extends Component {

    constructor(props) {
        super(props);

        this.unlisten = null;
        this.state = {}
    }

    componentDidMount() {
        this.unlisten = this.props.history.listen((location, action) => {

        });
    }

    componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.props.children}
            </React.Fragment>
        );
    }
}

export default (store, translator) => {
    function getComponent(Component, props) {
        return (
            <Component {...props} translate={(key, args) => translator.translate(key, args)}/>
        );
    }

    const history = createBrowserHistory();
    store.history = history;

    return (
        <Router history={history}>
            <RouterListener history={history} dispatch={store.dispatch} {...store.getState()}
                            translate={(key, args) => translator.translate(key, args)}>
                <Switch>
                    {/* Login, register, and reset password routes */}
                    <PublicRoute exact path="/" component={(props) => getComponent(Login, props)}/>
                    <PublicRoute exact path="/login" component={(props) => getComponent(Login, props)}/>

                    <PublicRoute exact path="/register" component={(props) => getComponent(RegisterView, props)}/>

                    <PublicRoute exact path="/reset-password"
                                 component={(props) => getComponent(ResetPassword, props)}/>
                    <NeutralRoute exact path="/reset-password-confirm/:email/:token/:is_new"
                                  component={(props) => getComponent(ResetPasswordConfirm, props)}/>
                    <NeutralRoute exact path="/reset-password-confirm/:email/:token"
                                  component={(props) => getComponent(ResetPasswordConfirm, props)}/>

                    <PrivateRoute exact path="/clients" component={(props) => getComponent(ClientsPage, props)}/>
                    <PrivateRoute exact path="/client/:id"
                                  component={(props) => getComponent(ClientSinglePage, props)}/>
                    <PrivateRoute exact path="/client-profile"
                                  component={(props) => getComponent(ClientProfilePage, props)}/>
                    <PrivateRoute exact path="/ailments" component={(props) => getComponent(AilmentsPage, props)}/>
                    <PrivateRoute exact path="/ailment/:id" component={(props) => getComponent(AilmentsSinglePage, props)}/>

                    <PrivateRoute exact path="/physicians" component={(props) => getComponent(PhysiciansPage, props)}/>
                    <PrivateRoute exact path="/locations" component={(props) => getComponent(LocationsPage, props)}/>
                    <PrivateRoute exact path="/assessments" component={(props) => getComponent(SurveysPage, props)}/>
                    <PrivateRoute exact path="/assessments/:id" component={(props) => getComponent(SurveysSinglePage, props)}/>

                    <PrivateRoute exact path="/settings-ailments" component={(props) => getComponent(LookupAilmentsPage, props)}/>

                    <PrivateRoute exact path="/preferences" component={(props) => getComponent(PreferencesPage, props)}/>
                    <PrivateRoute exact path="/users" component={(props) => getComponent(UsersPage, props)}/>
                    <PrivateRoute exact path="/devices" component={(props) => getComponent(LoggedDevicesPage, props)}/>

                    <PrivateRoute exact path="/welcome" component={(props) => getComponent(WelcomePage, props)}/>
                    <NeutralRoute component={(props) => getComponent(NotFoundView, props)}/>
                </Switch>
            </RouterListener>
        </Router>
    );
}
